<app-vcc-payment-gateway-viewer
  [title]="title"
  [data]="vcc"
  (innerLoadState)="handleLoadState($event)"
></app-vcc-payment-gateway-viewer>

@if(!isLoaderVisible){
  <transaction-history-list
    [guid]="guid"
    [data]="vcc">
  </transaction-history-list>
}
